<ng-container *ngIf="data$ | async as data">
  <ng-container *cxFeature="'a11yOrganizationsBanner'">
    <ng-container *ngIf="routerLink">
      <a
        [href]="routerLink"
      >
        <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
        <cx-media [container]="getImage(data)" [loading]="isHero(data) ? ImageLoadingStrategy.EAGER : ImageLoadingStrategy.LAZY" [fetchPriority]="isHero(data) ? ImageFetchPriority.HIGH : ImageFetchPriority.AUTO"></cx-media>
        <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
      </a>
    </ng-container>
  </ng-container>
  <ng-container *cxFeature="'!a11yOrganizationsBanner'">
    <a
      *ngIf="routerLink"
      [href]="routerLink"
    >
      <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
      <cx-media [container]="getImage(data)" [loading]="isHero(data) ? ImageLoadingStrategy.EAGER : ImageLoadingStrategy.LAZY" [fetchPriority]="isHero(data) ? ImageFetchPriority.HIGH : ImageFetchPriority.AUTO"></cx-media>
      <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
    </a>
  </ng-container>
  <ng-container *ngIf="!routerLink">
    <div class="no-link">
      <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
      <cx-media [container]="getImage(data)" [loading]="isHero(data) ? ImageLoadingStrategy.EAGER : ImageLoadingStrategy.LAZY" [fetchPriority]="isHero(data) ? ImageFetchPriority.HIGH : ImageFetchPriority.AUTO"></cx-media>
      <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
    </div>
  </ng-container>
</ng-container>